/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Form,
  Row,
  Col,
  Spin,
  Card,
  Button,
  Input,
  message,
} from 'antd';

import { onError } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import Select from 'components/Select';
import ModalDelete from 'components/ModalDelete';
import { hasActionPermission, ActionsNames } from 'utils/permission/index';
import {
  getInventariosPlacasTarjetasCirculaciones,
  getInventarioPlacaTarjetaCirculacion,
  patchInventarioPlacaTarjetaCirculacion,
  postInventarioPlacaTarjetaCirculacion,
  deleteInventarioPlacaTarjetaCirculacion,
} from 'api/recaudacion/inventarioPlacasTarjetasCirculacion';
import { getTiposFoliosVehiculares } from 'api/recaudacion/tipoFolioVehicular';
// import { getTiposDeVehiculos } from 'api/recaudacion/tipoVehiculo';
// import { getServiciosDeVehiculo } from 'api/recaudacion/servicioDeVehiculo';
import {
  getTiposDeVehiculos,
  getServiciosDeVehiculo,
} from 'api/recaudacion/index';
import { getContratosFoliosPlacas } from 'api/recaudacion/contratoFolioPlacas';
import { getUnidadesDeRecaudacion } from 'api/configuracion/unidadesDeRecaudacion';
import { getAlmacenesVehiculares } from 'api/recaudacion/almacenVehicular';
import { getEstadosFoliosPlacas } from 'api/recaudacion/estadoFolioPlacas';

const catalogsModel = [
  'tipofoliovehicular',
  'tipodevehiculo',
  'serviciodelvehiculo',
  'contratodefolioplaca',
  'unidadderecaudacion',
  'almacenvehicular',
  'estadodefolioplacaytarjeta',
];

const InventarioPlacaTarjetaCirculacion = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const estadosGlobales = useSelector(({ catalogs }) => catalogs.estadosGlobales);
  const [hasActionPermissions, setHasActionPermissions] = useState(true);
  const [tipoFolioVehicular, setTipoFolioVehicular] = useState([]);
  const [tipoVehiculo, setTipoVehiculo] = useState([]);
  const [servicioDeVehiculo, setServicioDeVehiculo] = useState([]);
  const [contratoFolioPlaca, setcontratoFolioPlaca] = useState([]);
  const [unidadDeRecaudacion, setUnidadDeRecaudacion] = useState([]);
  const [almacenVehicular, setAlmacenVehicular] = useState([]);
  const [estadoFolioPlaca, setEstadoFolioPlaca] = useState([]);
  const [formInfo] = Form.useForm();

  const fetchData = async () => {
    setLoading(true);
    const _data = await getInventariosPlacasTarjetasCirculaciones();
    setData(_data);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const validatePermission = () => {
      const _hasAllViewPermission = catalogsModel
        .map((m) => hasActionPermission(m, ActionsNames.view))
        .every((e) => e);
      if (!_hasAllViewPermission) {
        message.warn('Hacen falta permisos en los catálogos relacionados a este módulo');
      }
      if (mounted) {
        setHasActionPermissions(_hasAllViewPermission);
      }
    };
    validatePermission();
    const fetchAll = async () => {
      setLoading(true);
      const tipoFolioV = await getTiposFoliosVehiculares();
      const _tipoVehiculo = await getTiposDeVehiculos();
      const _servicioVehiculo = await getServiciosDeVehiculo();
      const _data = await getInventariosPlacasTarjetasCirculaciones();
      const _contratoFolioPlaca = await getContratosFoliosPlacas();
      const _UnidadDeRecaudacion = await getUnidadesDeRecaudacion();
      const _AlmacenVehicular = await getAlmacenesVehiculares();
      const _EstadoFolioPlaca = await getEstadosFoliosPlacas();
      if (mounted) {
        setTipoFolioVehicular(tipoFolioV || []);
        setTipoVehiculo(_tipoVehiculo || []);
        setServicioDeVehiculo(_servicioVehiculo || []);
        setcontratoFolioPlaca(_contratoFolioPlaca || []);
        setUnidadDeRecaudacion(_UnidadDeRecaudacion || []);
        setAlmacenVehicular(_AlmacenVehicular || []);
        setEstadoFolioPlaca(_EstadoFolioPlaca || []);
        setData(_data);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
    setSelectedRowKeys([]);
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickEdit = async () => {
    const [key] = selectedRowKeys;
    const match = await getInventarioPlacaTarjetaCirculacion(key);
    if (match) {
      setVisible(true);
      form.setFieldsValue(match);
      formInfo.setFieldsValue(match);
    }
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue({
      ...record,
      tipoFolioVehicular: record.tipoFolioVehicular.id,
    });
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formInfo.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formInfo.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      const _data = await (key ? patchInventarioPlacaTarjetaCirculacion(key, values)
        : postInventarioPlacaTarjetaCirculacion(values));
      if (_data) {
        await fetchData();
        if (_continue) {
          if (!key) {
            setSelectedRowKeys([_data.id]);
            setTimeout(() => onClickEdit(_data));
          } else {
            setTimeout(() => onClickEdit());
          }
        } else {
          onCancel();
        }
      }
      setLoading(false);
      return true;
    } catch (err) {
      onError(err, setLoading, [form, formInfo]);
      return false;
    }
  };

  const deleteItem = async () => {
    setLoading(true);
    if (selectedRowKeys.length) {
      const [key] = selectedRowKeys;
      const deleted = await deleteInventarioPlacaTarjetaCirculacion(key);
      if (deleted) {
        setVisibleAlert(false);
        onCancel();
        await fetchData();
      }
    }
    setLoading(false);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  /*
  const reset = () => {
    setTipoFolioVehicular([]);
    setTipoDeVehiculoFound([]);
    form.resetFields(['q']);
    form.validateFields(['q']);
  };
  */
  const rules = {
    required: [
      {
        required: true,
        message: 'El campo es requerido',
      },
    ],
  };

  const columns = [
    {
      titleText: 'Folio',
      dataIndex: 'folio',
      key: 'folio',
      width: 300,
    },
    {
      titleText: 'Tipo Folio Vehícular',
      dataIndex: 'tipo_folio_vehicular',
      key: 'tipo_folio_vehicular',
      width: 300,
      render: (val) => (tipoFolioVehicular.find((item) => item.id === val)?.descripcion),
    },
    {
      titleText: 'Contrato de Folio Placa',
      dataIndex: 'contrato_de_folio_placa',
      key: 'contrato_de_folio_placa',
      width: 300,
      render: (val) => (contratoFolioPlaca.find((item) => item.id === val)?.folio),
    },
    {
      titleText: 'Tipo de Vehículo',
      dataIndex: 'tipo_de_vehiculo',
      key: 'tipo_de_vehiculo',
      width: 300,
      render: (val) => (tipoVehiculo.find((item) => item.id === val)?.nombre),
    },
    {
      titleText: 'Servicio del Vehículo',
      dataIndex: 'servicio_del_vehiculo',
      key: 'servicio_del_vehiculo',
      width: 300,
      render: (val) => (servicioDeVehiculo.find((item) => item.id === val)?.nombre),
    },
    {
      titleText: 'Unidad de Recaudación',
      dataIndex: 'unidad_de_recaudacion',
      key: 'unidad_de_recaudacion',
      width: 300,
      render: (val) => (unidadDeRecaudacion.find((item) => item.id === val)?.descripcion),
    },
    {
      titleText: 'Almacén Vehícular',
      dataIndex: 'almacen_vehicular',
      key: 'almacen_vehicular',
      width: 300,
      render: (val) => (almacenVehicular.find((item) => item.id === val)?.nombre),
    },
    {
      titleText: 'Estado Folio',
      dataIndex: 'estado_de_folio_placa_tarjeta',
      key: 'estado_de_folio_placa_tarjeta',
      width: 300,
      render: (val) => (estadoFolioPlaca.find((item) => item.id === val)?.descripcion),
    },
    {
      titleText: 'Estado',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      render: (val) => (estadosGlobales.find((item) => item.id === val)?.descripcion),
      catalog: {
        cat: estadosGlobales,
        labelProp: 'descripcion',
      },
    },
  ];

  return (
    <Row align="center" justify="center" className="container">
      <Col xs={24} sm={24} md={24}>
        <Spin
          tip="Cargando..."
          spinning={loading}
        >
          {!visible ? (
            <Table
              cols={columns}
              data={data}
              rowKey="id"
              rowSelection={rowSelection}
              handleOnRowClick={handleOnRowClick}
              controls={{
                onClickAdd,
                onClickEdit,
                onClickDelete,
              }}
              loading={loading}
              hasAllViewPermission={hasActionPermissions}
              permission={permission}
            />
          ) : (
            <Card
              visible={visible}
              title={(
                <FormSubmitControls
                  label={`${selectedRowKeys.length ? ' Editar' : 'Agregar'} Almacén Vehícular`}
                  onCancel={onCancel}
                  loading={loading}
                  onFinish={onFinish}
                  permission={permission}
                />
              )}
              bordered={false}
            >
              <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
                initialValues={{ estados_globales: 1 }}
              >
                <Row gutter={10}>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="folio"
                      label="Folio"
                      rules={rules.required}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="placa_de_almacen"
                      label="Placa en Almacén"
                    >
                      <Select
                        trueFalse
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="tipo_folio_vehicular"
                      label="Tipo de Folio Vehícular"
                    >
                      <Select
                        dataSource={tipoFolioVehicular}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="contrato_de_folio_placa"
                      label="Contrato de Folio Placa"
                    >
                      <Select
                        dataSource={contratoFolioPlaca}
                        labelProp="folio"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="tipo_de_vehiculo"
                      label="Tipo de Vehículo"
                    >
                      <Select
                        dataSource={tipoVehiculo}
                        labelProp="nombre"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="servicio_del_vehiculo"
                      label="Servicio del Vehículo"
                    >
                      <Select
                        dataSource={servicioDeVehiculo}
                        labelProp="nombre"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="unidad_de_recaudacion"
                      label="Unidad De Recaudacion"
                    >
                      <Select
                        dataSource={unidadDeRecaudacion}
                        labelProp="descripcion"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="almacen_vehicular"
                      label="Almacén Vehícular"
                    >
                      <Select
                        dataSource={almacenVehicular}
                        labelProp="nombre"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="estado_de_folio_placa_tarjeta"
                      label="Estado del Folio de Placa"
                    >
                      <Select
                        dataSource={estadoFolioPlaca}
                        labelProp="descripcion"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="estados_globales"
                      rules={rules.required}
                      label="Estado"
                      hasFeedback
                    >
                      <Select dataSource={estadosGlobales} disabled={!selectedRowKeys.length} />
                    </Form.Item>
                  </Col>
                  <Form.Item hidden>
                    <Button htmlType="submit" />
                  </Form.Item>
                </Row>
              </Form>
            </Card>
          )}
          <ModalDelete
            onDelete={deleteItem}
            onCancel={() => setVisibleAlert(false)}
            visible={visibleAlert}
            content={`InventarioPlacaTarjetaCirculacion ${form.getFieldValue('nombre')}`}
            loading={loading}
          />
        </Spin>
      </Col>
    </Row>
  );
};

export default InventarioPlacaTarjetaCirculacion;
